import { useContext } from "react"
import PageContext from "global_state/context/PageContext"

import AppSCSS from 'assets/scss/App.module.scss'
import SCSS from 'assets/scss/CreateOnlineAccount.module.scss'
import FormSCSS from 'assets/scss/Form.module.scss'
import { PageType } from "types/PageI"

import content from 'languages/EmailSend.json'
import Title from "components/Title"



interface EmailSendProps {
    page?: PageType
}
function EmailSend(props: EmailSendProps) {
    const {page, dispatchPage}  = useContext(PageContext)
    let language = page.settings.language

    const handleSubmit = (event) => {
        // console.log(event);
        // event.stopPropagation();
        event.preventDefault()
        
        if ('page' in props) {
            dispatchPage({type: "render", payload: {page: props.page}})
            return 
        }

        dispatchPage({type: "render", payload: {page: PageType.log_in_form}})


    }

    return (
        <div className={[SCSS.email_send, FormSCSS.form_wrapper].join(" ")}>
            <Title back_arrow={false} title={content[language].title}/>

            <form className={FormSCSS.form} onSubmit={(event) => handleSubmit(event)}>
                <div>{content[language].text}</div>

                <button 
                    className={[AppSCSS.button, AppSCSS.red].join(" ")} 
                    type="submit">
                    {content[language].button_submit}
                </button>
            </form>
        </div>
    )
}

export default EmailSend